import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL;

// 🔹 Add a New Rating
export const addRating = createAsyncThunk("ratings/addRating", async (ratingData, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.post("${BASE_URL}/api/rating/add", ratingData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

// 🔹 Update a Rating
export const updateRating = createAsyncThunk("ratings/updateRating", async ({ id, ratingData }, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.put(`${BASE_URL}/api/rating/update/${id}`, ratingData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

// 🔹 Fetch All Ratings
export const getAllRatings = createAsyncThunk("ratings/getAllRatings", async () => {
  const response = await axios.get(`${BASE_URL}/api/rating/all`);
  return response.data;
});

// 🔹 Fetch All Ratings
export const getRatingsByProductId = createAsyncThunk("ratings/getRatingsByProductId", async (productId) => {
  const response = await axios.get(`${BASE_URL}/api/rating/${productId}`);
  return response.data;
});

// 🔹 Fetch All Ratings
export const getRatingsByUserId = createAsyncThunk("ratings/getRatingsByUserId", async (userId) => {
  const response = await axios.get(`${BASE_URL}/api/rating/user/${userId}`);
  return response.data;
});

export const ratingSlice = createSlice({
  name: "ratings",
  initialState: {
    ratings: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addRating.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addRating.fulfilled, (state, action) => {
        state.loading = false;
        state.ratings.push(action.payload);
        state.success = true;
      })
      .addCase(addRating.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.success = false;
      })

      .addCase(updateRating.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateRating.fulfilled, (state, action) => {
        state.loading = false;
        state.ratings = state.ratings.map((rating) => (rating._id === action.payload._id ? action.payload : rating));
        state.success = true;
      })
      .addCase(updateRating.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.success = false;
      })

      .addCase(getAllRatings.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.ratings = [];
        state.success = false;
      })
      .addCase(getAllRatings.fulfilled, (state, action) => {
        state.loading = false;
        state.ratings = action.payload;
        state.success = true;
      })
      .addCase(getAllRatings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.success = false;
      })

      .addCase(getRatingsByProductId.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.ratings = [];
      })
      .addCase(getRatingsByProductId.fulfilled, (state, action) => {
        state.loading = false;
        state.ratings = action.payload;
        state.success = true;
      })
      .addCase(getRatingsByProductId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.success = false;
      })

      .addCase(getRatingsByUserId.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.ratings = [];
        state.success = false;
      })
      .addCase(getRatingsByUserId.fulfilled, (state, action) => {
        state.loading = false;
        state.ratings = action.payload;
        state.success = true;
      })
      .addCase(getRatingsByUserId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.success = false;
      })

  },
})

export default ratingSlice.reducer